import { FC, useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useNotification } from 'lib/context/notification.context'

interface ProtectedRouteProps {
  children: JSX.Element
  requireAdminPlatformManagement?: boolean
}

const ProtectedRoute: FC<ProtectedRouteProps> = ({
  children,
  requireAdminPlatformManagement = false
}) => {
  const hasAdminPlatformManagement = useSelector((state: any) => state.user.hasAdminPlatformManagement)
  const { getWarning } = useNotification()

  useEffect(() => {
    if (requireAdminPlatformManagement && !hasAdminPlatformManagement) {
      getWarning('No tienes permisos para acceder a esta sección')
    }
  }, [requireAdminPlatformManagement, hasAdminPlatformManagement, getWarning])

  if (requireAdminPlatformManagement && !hasAdminPlatformManagement) {
    return <Navigate to="/" replace />
  }

  return children
}

export default ProtectedRoute

